/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import type { StackDeployment } from '@modules/ui-types'

import { getStackDeployment } from '@/reducers/stackDeployments'

import LogsMetrics from './LogsMetrics'

type StateProps = {
  deployment: StackDeployment | undefined
}

interface ConsumerProps {}

interface DispatchProps {}

const mapStateToProps = (
  state,
  {
    match: {
      params: { deploymentId },
    },
  },
): StateProps => ({
  deployment: getStackDeployment(state, deploymentId),
})

export default connect<StateProps, DispatchProps, ConsumerProps>(mapStateToProps, {})(LogsMetrics)
